import {
  getLeasingPricesFromFilters,
  getRentPricesFromFilters
} from "./getSelectedCalculatorPrice";
import type { CalculatorData } from "../types/calculatorData";

export interface CalculatorFilterPayload {
  FinancingMethod: number;
  Filters: {
    Period?: number;
    Ow?: number;
    Mileage?: number;
    Mileages?: number;
    Rv?: number;
    Rvs?: number;
    AdditionalServices?: number[];
    Price?: number;
    HP?: number;
    isNew?: boolean;
    isElectric?: boolean;
    isTruck?: boolean;
    AuctionId?: number;
    CalculatorLongTermTypeId?: number;
    CalculatorLeasingTypeId?: number;
  };
}

function normalizeFilters(filters: CalculatorFilterPayload["Filters"]) {
  return {
    Period: filters.Period,
    Ow: filters.Ow,
    Mileage: filters.Mileage ?? filters.Mileages,
    Rv: filters.Rv ?? filters.Rvs
  };
}

/** Builds CalculationResult shape from cached calculator tree (no InstallmentCalculator POST). */
export function buildCalculationResultFromCalculatorData(
  calculatorData: CalculatorData,
  filters: CalculatorFilterPayload,
  isNewVehicle: boolean
) {
  const normalized = normalizeFilters(filters.Filters);
  let installmentPrice: number | undefined;
  let ow: number | undefined;
  let rv: number | undefined;
  let insurancePrice: number | undefined;
  let isPriceFromCalculator = false;

  if (filters.FinancingMethod === 1 && normalized.Period != null && normalized.Ow != null && normalized.Mileage != null) {
    const prices = getRentPricesFromFilters(calculatorData, {
      Period: normalized.Period,
      Ow: normalized.Ow,
      Mileage: normalized.Mileage
    });
    if (prices) {
      installmentPrice = prices.installmentPrice;
      ow = prices.owPrice;
      insurancePrice = prices.insurancePrice;
      isPriceFromCalculator = true;
    }
  } else if (
    filters.FinancingMethod === 2 &&
    normalized.Period != null &&
    normalized.Ow != null &&
    normalized.Rv != null
  ) {
    const prices = getLeasingPricesFromFilters(calculatorData, {
      Period: normalized.Period,
      Ow: normalized.Ow,
      Rv: normalized.Rv
    });
    if (prices) {
      installmentPrice = prices.installmentPrice;
      ow = prices.owPrice;
      rv = prices.rvValuePLN;
      insurancePrice = prices.insurancePrice;
      isPriceFromCalculator = true;
    }
  }

  return {
    IsPriceFromCalculator: isPriceFromCalculator,
    InstallmentPriceFromCalculator: installmentPrice,
    InstallmentPrice: installmentPrice,
    InstallmentPricePromo: -1,
    InstallmentFinalPrice: installmentPrice,
    InsuranceAdditionalText: calculatorData.InsuranceAdditionalText,
    InsurancePriceInfo: insurancePrice,
    Ow: ow,
    Rv: rv,
    TotalFees: -1,
    params: filters,
    isNewVehicle
  };
}
